import type { JobTitleValue } from '@/constants/job-titles';

export type OnboardingObjectiveChoice =
  | 'hire_clippers'
  | 'clipping_channels'
  | 'ai_clipping';

/**
 * Display order of the objective cards. Hiring clippers is a service, not a
 * way to use the app, so it comes last (2026-10-19).
 */
export const ONBOARDING_OBJECTIVE_CHOICES: readonly OnboardingObjectiveChoice[] = [
  'ai_clipping',
  'clipping_channels',
  'hire_clippers',
];

export const ONBOARDING_EXPERIENCES = [
  'starting_from_zero',
  'started_not_monetizing',
  'experienced_with_clips',
  'monetizing_clipping_channel',
] as const;

export type OnboardingExperience = typeof ONBOARDING_EXPERIENCES[number];

export type ObjectiveSelection = {
  readonly onboardingObjective: 'own_brand' | 'other_channels';
  readonly jobTitle: Extract<
    JobTitleValue,
    'content-creator' | 'clipping-channel' | 'brand'
  >;
  readonly asksExperience: boolean;
};

const OBJECTIVE_SELECTIONS: Record<
  OnboardingObjectiveChoice,
  ObjectiveSelection
> = {
  hire_clippers: {
    onboardingObjective: 'own_brand',
    jobTitle: 'brand',
    asksExperience: false,
  },
  clipping_channels: {
    onboardingObjective: 'other_channels',
    jobTitle: 'clipping-channel',
    asksExperience: true,
  },
  // Creators and agencies share one card since 2026-10-14; new agency
  // signups are stored as content creators.
  ai_clipping: {
    onboardingObjective: 'own_brand',
    jobTitle: 'content-creator',
    asksExperience: false,
  },
};

export function resolveObjectiveSelection(
  choice: OnboardingObjectiveChoice,
): ObjectiveSelection {
  return { ...OBJECTIVE_SELECTIONS[choice] };
}
